import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { DefaultPaymentMethod } from 'organisms/DefaultPaymentMethod';
import { isEmpty, isNotEmptyArray } from 'util';

export default function PaymentMethod({ setPaymentMethod, paymentMethod }) {
  const { paymentMethodType } = useSelector((state) => state.main.core);
  const { appointment } = useSelector((state) => state.checkout);
  const cardsOnFile = appointment?.user?.payment?.methods?.cards;
  const lastCard = cardsOnFile?.[0] || {};

  useEffect(() => {
    if (!isNotEmptyArray(cardsOnFile) || isEmpty(lastCard)) {
      setPaymentMethod(
        paymentMethodType.find((method) => method.value === 'Cash')
      );
    } else {
      setPaymentMethod(
        paymentMethodType.find((method) => method.value === 'Card')
      );
    }
  }, [cardsOnFile]);

  return (
    <div className="mb-12 p-24 border-light-purple radius-24 flex-column">
      <h4 className="mb-8">Payment</h4>
      {paymentMethodType.map((method) =>
        method.value === 'Card' ? (
          <button
            key={method.id}
            onClick={() => setPaymentMethod(method)}
            className="no-style-btn"
          >
            <DefaultPaymentMethod
              cards={cardsOnFile}
              savedCardLabel
              isActive={paymentMethod.id === method.id}
            />
          </button>
        ) : (
          <button
            key={method.id}
            onClick={() => setPaymentMethod(method)}
            className={classNames(
              ' p-24 radius-16 mt-15 pointer',
              paymentMethod.id === method.id
                ? 'border-primary-orange b-light-orange'
                : 'border-light-purple b-white'
            )}
          >
            <div className="flex-row">
              <div
                className={classNames(
                  'radius-50 radio-btn radius-100 flex-row justify-center',
                  paymentMethod.id === method.id
                    ? 'border-primary-orange'
                    : 'border-black'
                )}
              >
                <span
                  className={classNames(
                    'radius-100',
                    paymentMethod.id === method.id
                      ? 'b-primary-orange'
                      : 'b-white'
                  )}
                />
              </div>
              <p className="f13 bold">{method.value}</p>
            </div>
          </button>
        )
      )}
    </div>
  );
}
